
import './App.css';
import TopAppBar from './components/TopAppBar';
import { CheckoutLayout } from './components/CheckoutLayout';
import { Box } from '@mui/material';
import appConfigJson from './config/app-config.json';
import type { AppConfig } from './types/appConfig';

import useAuthToken from './hooks/useAuthToken';
import { AuthTokenContext } from './context/AuthTokenContext';
import { QueryParamsContext } from './context/QueryParamsContext';
import { LocaleProvider } from './context/LocaleContext';


const appConfig = appConfigJson as AppConfig;



export default function App() {
  // Parse query params once at app level
  let memberCardNumber = '';
  let legacyAccountId = '';
  let clientType = '';
  let countryParam = '';
  let locationNumber = '';
  let userId = '';
  let linkId = '';
  let sid = '';
  try {
    const qp = new URLSearchParams(window.location.search);
    memberCardNumber = qp.get('MemberCardNumber') || qp.get('memberCardNumber') || '';
    legacyAccountId = qp.get('LegacyAccountId') || qp.get('legacyAccountId') || '';
    clientType = qp.get('ClientType') || qp.get('clientType') || '';
    const ctryRaw = qp.get('Country') || qp.get('country') || '';
    if (ctryRaw) {
      const upper = ctryRaw.toUpperCase();
      countryParam = upper;
    }
    locationNumber = qp.get('locationNumber') || qp.get('locationNumber') || '';
    userId = qp.get('userId') || qp.get('UserId') || qp.get('userid') || '';
    linkId = qp.get('linkId') || qp.get('LinkId') || '';
    sid = qp.get('sid') || '';
  } catch (e) {
    // ignore
  }

  // Fetch the auth token once at the app level
  const tokenUrl = appConfig.authTokenUrl || '';
  const scope = appConfig.authTokenScope || '';
  const { authToken, authError } = useAuthToken({ tokenUrl, scope, clientType, sid });

  return (
    <LocaleProvider>
      <AuthTokenContext.Provider value={{ authToken, authError }}>
        <QueryParamsContext.Provider value={{ memberCardNumber, legacyAccountId, clientType, countryParam, locationNumber, userId, linkId }}>
          <Box style={{ minHeight: '100%', minWidth: '100%', display: 'flex', flexDirection: 'column' }}>
            <TopAppBar />
            <CheckoutLayout/>
          </Box>
        </QueryParamsContext.Provider>
      </AuthTokenContext.Provider>
    </LocaleProvider>
  );
}
